import { render, staticRenderFns } from "./kmLayout.vue?vue&type=template&id=bedfe8e4&"
import script from "./kmLayout.vue?vue&type=script&lang=js&"
export * from "./kmLayout.vue?vue&type=script&lang=js&"
import style0 from "./kmLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports